/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editdone1Inputs */

const en_editdone1 = /** @type {(inputs: Editdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved to your media library.`)
};

const de_editdone1 = /** @type {(inputs: Editdone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In deiner Mediathek gespeichert.`)
};

/**
* | output |
* | --- |
* | "Saved to your media library." |
*
* @param {Editdone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editdone1 = /** @type {((inputs?: Editdone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editdone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editdone1(inputs)
	return de_editdone1(inputs)
});
export { editdone1 as "editDone" }